<template>
  <v-banner
    v-show="show && accountBalance && accountBalance.creditBalance <= 500"
    dark
    :elevation="8"
    :single-line="false"
    sticky
    style="background: #E53935; z-index: 3;"
  >
    <v-avatar slot="icon" size="25">
      <v-icon icon="mdi-lock" color="white">mdi-lock</v-icon>
    </v-avatar>

    <b>¿Te cansan las limitaciones?</b> Rompe los topes de tu cuenta gratuita y
    obtén más beneficios.
    <template v-slot:actions>
      <v-btn dark text @click="close()">Cerrar</v-btn>
      <v-btn dark outlined text tile @click="goSite()">Mejorar plan</v-btn>
    </template>
  </v-banner>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "FreeAccountBanner",

  data: () => ({
    show: true,
    handler: null
  }),

  computed: {
    ...mapGetters({
      accountBalance: "getAccountBalance"
    })
  },

  methods: {
    goSite() {
      window.open("https://fontumi.co/web_2019/#pricing", "_blank").focus();
    },

    close() {
      this.show = false;
      setTimeout(() => (this.show = true), 30000);
    },

    openCheckout() {
      // TODO
      if (this.handler)
        this.handler.open({
          name: "Vestido Mujer Primavera",
          description: "Vestido Mujer Primavera",
          currency: "cop",
          amount: "59000",
          country: "co",
          lang: "es,en",

          external: false,

          extra1: "extra1",
          extra2: "extra2",
          extra3: "extra3",
          confirmation: "https://fontumi.web.app/#/",
          response: "https://fontumi.web.app/#/"
        });
    }
  },

  mounted() {
    const scr = document.createElement("script");
    scr.src = "https://checkout.epayco.co/checkout.js";

    scr.onload = () => {
      this.handler = ePayco.checkout.configure({
        key: "26183b4d6cfd7ac719ec72b3845b37dc",
        test: true
      });
    };

    document.head.appendChild(scr);
  }
};
</script>
